import React, { useState, useEffect } from "react";
import {Button, Col, Modal, Row, Spin, Form, notification} from "antd";
import InputField from "@components/input-field";
import { edoService } from "../../../services/edo.services";
import ModalEdoAuth from "../edo-auth";
import SelectField from "../../select-field";
import { Redirect } from "react-router-dom";

export default function ModalEdoSend({legalEntityId, isShow, setIsShow, type = 'simple', orderId = null, contractId = null}) {
  const [loading, setLoading] = useState(false);
  const [fieldsErrors, setFieldsErrors] = useState({});
  const [isNeedUpdateEntities, setIsNeedUpdateEntities] = useState(false);
  const [isNeedGetAccount, setIsNeedGetAccount] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [edoAbonents, setEdoAbonents] = useState([]);
  const [abonentId, setAbonentId] = useState(null);
  const [recipient, setRecipient] = useState(null);
  const [currentType, setCurrentType] = useState(null);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [redirectToSettings, setRedirectToSettings] = useState(false);

  const [contactsList, setContactsList] = useState([]);

  const [actualDocs, setActualDocs] = useState(null);
  const [actualStatus, setActualStatus] = useState(null);

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px' };

  const getFieldErrors = fieldName => {
    return (typeof fieldsErrors !== "undefined" && typeof fieldsErrors[fieldName] !== "undefined")
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
          return fieldErrors + "; " + error;
        })
      : null;
  };

  useEffect(() => {
    if(isShow) {
      setAbonentId(null);
      setEdoAbonents([]);
      setIsNeedUpdateEntities(true);
      setFieldsErrors([]);
      setActualDocs(null);
      setActualStatus(null);
      setRecipient(null);
      setContactsList([]);
      setCurrentType(null);
    }
  }, [isShow]);

  useEffect(() => {
    if(abonentId) {
      setLoadingContacts(true);
      edoService.getContact(abonentId, orderId, contractId)
      .then((res) => {
        if(res.status && res.status === 'error' && res.type === 'need_auth') {
          setCurrentType(res.edo_type);
          setShowLoginForm(true);
          setLoadingContacts(false);
        } else {
          setRecipient(null);
          setContactsList(res);
          if(res.length > 0) {
            setRecipient(res[0].Id);
          } 
          setLoadingContacts(false);
        }
      })
      .catch((error) => {
        setRecipient(null);
        setContactsList([]);
        notification.error({
          message: "Получение данных о получателе", description: error,
        });
      });
    }
  }, [abonentId]);

  useEffect(() => {
    if (isNeedUpdateEntities) {
        if(orderId || contractId) {
          edoService.getDocs(orderId, contractId)
            .then((res) => {
              let doc = res[type];
              if(doc) {
                setActualDocs(doc.carrierLinks);
                setActualStatus(doc.statusTitle);
              }
            })
            .catch((error) => {
              notification.error({
                message: "Получение данных о документах", description: error,
              });
            });
        }
    }
  }, [isNeedUpdateEntities]);

  useEffect(() => {
    if (isNeedUpdateEntities) {
      setLoading(true);
      setAbonentId(null);
      edoService
        .getCompanies(legalEntityId)
        .then((response) => {
          let reindexedData = [];
          response.forEach((item) => {
            if(item.EdoCompanies.length > 0) {
              item.EdoCompanies.forEach((company) => {
                reindexedData.push({
                  "Id": company.id,
                  "Name": company.type
                });
              });
            } else {
              setErrorMsg('Абонентов ЭДО не найдено. Перейдите в Раздел "Моя компания" > "Настройки ЭДО" для добавления операторов документооборота.');
            }
          });

          setEdoAbonents(reindexedData);
          if(reindexedData.length === 1) {
            setAbonentId(reindexedData[0].Id);
          }
          setIsNeedUpdateEntities(false);
          setLoading(false);
        })
        .catch((errorMsg) => {
          setIsNeedUpdateEntities(false);
          notification.error({message: "Ошибка", description: errorMsg});
          setLoading(false);
        });
    }
  }, [isNeedUpdateEntities]);

  const onSubmitFormEdoSend = e => {
    e.preventDefault();
    setLoading(true);
    edoService.sendDraft(abonentId, type, orderId, contractId, recipient)
      .then((response) => {
          setLoading(false);
          if (response.status === "success") {
              notification.success({message: "Отправка документа в ЭДО", description: response.message});
              if(response.links) {
                setActualDocs(response.links);
              }
          } else if (response.status === "error"){
              setFieldsErrors(response.errors);
              notification.error({message: "Отправка документа в ЭДО", description: response.message});
          }
      })
      .catch((error) => {
          notification.error({message: "Отправка документа в ЭДО", description: error});
          setLoading(false);
      });
  };

  const handleGoToLink = link => {
    window.open(link, '_blank', 'noopener,noreferrer');
  }

  const handleRedirectToEdoSettings = () => {
    setRedirectToSettings(true);
  }

  if(redirectToSettings) {
    return (<Redirect to="/company/epd-astral" push={true} />)
  }

  return (
    <>
      <Modal
        title={`Отправка документа в ЭДО`}
        cancelText="Закрыть"
        className="modal-window"
        align={null}
        visible={isShow}
        onCancel={() => {
          setIsShow(false);
        }}
        footer={[
          <>
          {!actualDocs && <Button htmlType="submit" key="submit" disabled={!abonentId || loading || loadingContacts} style={bigButtonStyle} type="primary" onClick={onSubmitFormEdoSend}>
            Отправить
          </Button>}
          </>
        ]}
      >
        {errorMsg && 
          <div className="content-error-block">
            {errorMsg}
            <div>
              <Button htmlType="submit" style={bigButtonStyle} key="submit" type="primary" onClick={() => {handleRedirectToEdoSettings()}}>Перейти к настройкам</Button>
            </div>
          </div>}
        {!errorMsg && <Spin spinning={!edoAbonents} tip="Загрузка...">
          {actualDocs &&
            Object.keys(actualDocs).map((key) => {
              return (<>
              <p>Документ загружен. {actualStatus}</p>
              <Button style={{ marginLeft: "0px", width: "100%" }} onClick={() => handleGoToLink(actualDocs[key])} size="small" className="small-button typical-btn-green">
                  Перейти в ЭДО
              </Button>
              </>)
            })}
          {!actualDocs && <Form>
              <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
                <Col lg={24} md={24} sm={24} sx={24}>
                  <SelectField
                    title="Выбор оператора"
                    name="abonentId"
                    selectedValue={abonentId}
                    values={edoAbonents}
                    onChange={value => {
                      setAbonentId(value);
                    }}
                    getErrors={getFieldErrors}
                    style={{width: "100%"}}
                  />
                </Col>
              </Row>
              <Spin spinning={loadingContacts} tip="Загрузка...">
              <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
                <Col lg={24} md={24} sm={24} sx={24}>
                {contactsList.length > 0 &&
                  <SelectField
                    title="Получатель"
                    name="recipient"
                    selectedValue={recipient}
                    values={contactsList}
                    onChange={value => {
                      setRecipient(value);
                    }}
                    getErrors={getFieldErrors}
                    style={{width: "100%"}}
                  />
                }
                {abonentId && contactsList.length === 0 &&
                  <p>Подходящий получатель не найден. Вы можете выбрать получателя позже, в системе ЭДО</p>
                } 
                </Col>
              </Row>
              </Spin>
            </Form>
          }
        </Spin>}
      </Modal>
      <ModalEdoAuth type={currentType} isShow={showLoginForm} setIsShow={setShowLoginForm} setIsNeedUpdate={setIsNeedUpdateEntities} />
    </>
  );
}
